import styled from "styled-components"

export const ContentWrapper = styled.section`
    margin-left: 262px;
    padding: 0 56px;
    width: -webkit-fill-available;
    position: fixed;
    top: 0;

  @media screen and (max-width: 1280px){
        margin-left: 0;
    }

  @media screen and (max-width: 850px){
        padding: 0 15px;
    }
`